import { LocalizedPageTitle, LocalizedParagraph, useEnterpriseNavigate } from '@mews-commander/ui';
import { Button, Icon, IconName, Stack } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { BaseLayout } from '../../../../components/layout';
import { useRequestActionAuthorization } from './useRequestActionAuthorization';

interface AdditionalAuthorizationPageProps {
    referrer?: string;
}

export const AdditionalAuthorizationPage = ({ referrer }: AdditionalAuthorizationPageProps) => {
    const navigate = useEnterpriseNavigate();
    const { mutate: requestActionAuthorization } = useRequestActionAuthorization({
        onSuccess: async () => {
            await navigate({ to: 'Dashboard/Index' });
        },
    });

    return (
        <BaseLayout padded shadowed={false}>
            <Stack alignment="center" itemAlignment="center">
                <Stack vertical spacing="300" style={{ maxWidth: '400px' }}>
                    <Stack spacing="100">
                        <Icon value={IconName.Lock} size="large" />
                        <LocalizedPageTitle textKey={TextKey.ReverifyModalTitle} />
                    </Stack>
                    <LocalizedParagraph textKey={TextKey.ReverifyModalDescription} />
                    <Button
                        type="submit"
                        variant="primary"
                        size="medium"
                        onClick={() =>
                            requestActionAuthorization({
                                referrer,
                            })
                        }
                    >
                        {lt('GeneralSendLink')}
                    </Button>
                </Stack>
            </Stack>
        </BaseLayout>
    );
};
